/**
 * @generated SignedSource<<9913734039e182e2f3bedd5aeca683ef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type NotificationsQuery$variables = Record<PropertyKey, never>;
export type NotificationsQuery$data = {
  readonly notification_types: ReadonlyArray<{
    readonly id: string;
  }>;
};
export type NotificationsQuery = {
  response: NotificationsQuery$data;
  variables: NotificationsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "NotificationType",
    "kind": "LinkedField",
    "name": "notification_types",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "NotificationsQuery",
    "selections": (v0/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "NotificationsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "c61e3067ca803784e4fa5659d33ca5a5",
    "id": null,
    "metadata": {},
    "name": "NotificationsQuery",
    "operationKind": "query",
    "text": "query NotificationsQuery {\n  notification_types {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "39eedc61325f8fa891c3b631a4274de5";

export default node;
